import { render, staticRenderFns } from "./pricehelp.vue?vue&type=template&id=6fd1ac6d&"
import script from "./pricehelp.vue?vue&type=script&lang=js&"
export * from "./pricehelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6fd1ac6d')) {
      api.createRecord('6fd1ac6d', component.options)
    } else {
      api.reload('6fd1ac6d', component.options)
    }
    module.hot.accept("./pricehelp.vue?vue&type=template&id=6fd1ac6d&", function () {
      api.rerender('6fd1ac6d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-20Z1ziZpc0DrW/JS/pricehelp.vue"
export default component.exports